import React from 'react';
import { Route } from 'react-router-dom';
import PageTemplate from '../../components/common/template/PageTemplate';

import * as PATH from '../../lib/routes/path';
import ClearfaceOrder from './Clearface/ClearfaceOrder';

const Order = () => {
  return (
    <PageTemplate>
      <Route exact path={PATH.ORDER_CLEARFACE} component={ClearfaceOrder} />
    </PageTemplate>
  );
};

export default Order;
